import UnilevelLegsComponent from './UnilevelLegs.component';
import UnilevelLegsEditor from './UnilevelLegs.editor';
import { UnilevelLegsProps, UnilevelLegsEditorProps } from './UnilevelLegs.types';
import { adaptUnilevelLegsProps, adaptUnilevelLegsEditorProps } from './UnilevelLegs.adapter';
import UnilevelLegsProperties from '../../propertyPanel/ComponentProperties/UnilevelLegsProperties';
import { registerSkinnableComponent, registerPropertyPanel } from '../registry';
import { UnilevelLegsSkinnable } from './UnilevelLegsSkinnable';
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(UnilevelLegsSkinnable);

// 속성 패널 등록
registerPropertyPanel(COMPONENT_TYPES.UNILEVEL_LEGS, UnilevelLegsProperties);

// 일반 사용을 위한 기본 내보내기
export default UnilevelLegsComponent;

// 명명된 내보내기
export { 
  UnilevelLegsComponent,
  UnilevelLegsEditor,
  adaptUnilevelLegsProps,
  adaptUnilevelLegsEditorProps
};

// 타입 내보내기
export type { 
  UnilevelLegsProps, 
  UnilevelLegsEditorProps 
};